import { render, staticRenderFns } from "./SdsFileCard.vue?vue&type=template&id=5ce0a358&scoped=true"
import script from "./SdsFileCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsFileCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SdsFileCard.vue?vue&type=style&index=0&id=5ce0a358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce0a358",
  null
  
)

export default component.exports